import { render } from "./item.vue?vue&type=template&id=1c6f0eb6&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=1c6f0eb6&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\forome\\site-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6f0eb6"]])

export default __exports__